import { createApiCall } from 'lib/base';

const POST_INVESTMENT_PLANS_API_ID = 'INVESTCORE/POST_INVESTMENT_PLANS_API';

const apiCall = createApiCall(
  POST_INVESTMENT_PLANS_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/investment-plans`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);

export default apiCall;
